// theme.js
export const lightTheme = {
  body: '#B59BFA',
  text: '#000000',
  windowBg: '#FFFFFFDD',
  shadowColor: '#808080EF',
  hoverColor: '#DCDCDC',

  link: '#AB2EFF',
}

export const darkTheme = {
  body: '#544875',
  text: '#FCFCFC',
  windowBg: '#2A2A2AEF',
  shadowColor: '#202020EF',
  hoverColor: '#575757',

  link: '#C266FF',
}
